/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelWebPayment64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelWebPayment64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28 32C28 34.916 28.5931 37.5065 29.5053 39.331C30.2845 40.8894 31.183 41.6957 32 41.9279V43C25.9249 43 21 38.0751 21 32V31H21.0448C21.5501 25.3935 26.262 21 32 21C32.1115 21 32.2226 21.0017 32.3333 21.005C32.3887 21.0017 32.4442 21 32.5 21C32.6685 21 32.8353 21.0152 33 21.0448C37.9392 21.4899 41.9369 25.1999 42.8186 30H41.8C41.0972 26.5378 38.6058 23.7252 35.3322 22.5686C36.658 24.1646 37.6197 26.8471 37.9093 30H36.9049C36.703 27.9065 36.1921 26.0639 35.4947 24.669C34.6675 23.0146 33.7058 22.2079 32.85 22.0356C32.6862 22.0218 32.5212 22.012 32.3552 22.0062C31.4504 22.0831 30.3993 22.881 29.5053 24.669C28.6988 26.2821 28.1418 28.4939 28.0235 31H32V32H28ZM27 32C27 36.2741 28.2188 39.9788 29.9993 41.7998C25.4351 40.873 22 36.8377 22 32H27ZM22.0494 31C22.4848 26.6144 25.7536 23.0624 29.9993 22.2002C28.3592 23.8776 27.1957 27.1533 27.0224 31H22.0494Z"
              fill="currentColor"
            />
            <path
              d="M38 32V34H37.5C36.1193 34 35 35.1193 35 36.5C35 37.8807 36.1193 39 37.5 39H39.5C40.3284 39 41 39.6716 41 40.5C41 41.3284 40.3284 42 39.5 42H35.5V43H38V45H39V43H39.5C40.8807 43 42 41.8807 42 40.5C42 39.1193 40.8807 38 39.5 38H37.5C36.6716 38 36 37.3284 36 36.5C36 35.6716 36.6716 35 37.5 35H41.5V34H39V32H38Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelWebPayment64Icon.tags = [
  'web',
  'payment',
  'currency',
  'global',
  'finance',
];

AddPanelWebPayment64Icon.category = '64x64 (Add panel)';

AddPanelWebPayment64Icon.iconSize = 64;
